import React, { useEffect } from "react";
import { Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNotificationStore } from "../Zustand/notification.store";

export const GlobalNotification = () => {
  const { open, message, severity, close } = useNotificationStore();

  /**
   * Effects
   */
  // 🟡 Effect - Close global message after 8 seconds
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        close();
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, [open, close]);

  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 24,
        left: 0,
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        zIndex: 1300,
        pointerEvents: "none",
      }}
    >
      <div style={{ pointerEvents: "auto" }}>
        <Alert
          severity={severity}
          sx={{ minWidth: 320 }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={close}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {message}
        </Alert>
      </div>
    </div>
  );
};
